import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const StrategicFinancialLeadershipWithoutAFullTimeCFO = () => {
  const serviceData = {
    title: "Strategic Financial Leadership",
    heading: "Strategic Financial Leadership",
    image: subTopicImages["Strategic Financial Leadership"],
    intro: "CFO-Level Financial Leadership — Without a Full-Time CFO",
    description: [
      "Growing businesses and multinational subsidiaries often need strategic financial leadership, but may not yet require or be ready for a full-time Chief Financial Officer.",
      "We act as your outsourced CFO — delivering financial leadership, planning insight and strategic guidance without the cost of a full-time executive.",
    ],
    services: [
      {
        title: "Strategic Financial Leadership",
        text: "We act as your outsourced CFO — delivering financial leadership, planning insight and strategic guidance without the cost of a full-time executive.",
        extraInfo:
          "Our Virtual CFO becomes a trusted part of your leadership team, helping you align financial strategy with business priorities and growth plans.",
      },
    ],
    benefitsIntro: "Key Features:",
    benefits: [
      "Financial leadership & planning insight",
      "Strategic guidance without high executive costs",
      "Trusted partnership in leadership teams",
      "Alignment of financial strategy with business priorities",
    ],
    research:
      "Our Virtual CFO becomes a trusted part of your leadership team, helping you align financial strategy with business priorities and growth plans.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default StrategicFinancialLeadershipWithoutAFullTimeCFO;
